import React, { Component } from 'react';

export class WebNetConfig extends Component {
    displayName = WebNetConfig.name

  constructor(props) {
    super(props);
    this.state = { clients: [], loading: true };

    fetch('api/SampleData/Clients')
      .then(response => response.json())
      .then(data => {
        this.setState({ clients: data, loading: false });
      });
  }
// Example process result from fetch "clients" 
  static renderForecastsTable(clients) {
    return (
      <table className='table'>
        <thead>
          <tr>
            <th>Name</th>
            <th>Date</th>
            <th>Company</th>
          </tr>
        </thead>
        <tbody>
            {clients.map(client =>
                <tr key={client.name}>
                <td>{client.name}</td>
                <td>{client.dateFormatted}</td>
                <td>{client.company}</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }

  render() {
    return (
        <div>
            <h1>"WebNet settings" </h1>
            <p>Camera , temperature, color-pattern....(?) </p>
            <ul>
                <li><a href=''>Camera </a> Camera </li>
                <li><a href=''>temperature</a> temperature</li>
                <li><a href=''>pattern</a> pattern</li>
            </ul>
            <p>WebNet details....</p>
            <ul>
                <li><strong>WebNet details....</strong>WebNet details....</li>
            </ul>

        </div>
    );
  }
}
